<script lang="ts">
    import Icon from '../../components/Icon.svelte';
    import { useNavigate } from 'svelte-navigator'
    import sessionStore from '../../store/session';
    import { createContact as CreateContact, updateContact as UpdateContact } from '../../domain/call/contact.action'
    import type { Profile } from '../../types/session';
    import AuthHeader from '../../components/AuthHeader.svelte';
    import AuthFooter from '../../components/AuthFooter.svelte';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import { useLocation } from "svelte-navigator";
    import { onMount } from "svelte";
    import toast from '../../services/toast';
    import { initiateCall } from '../../domain/call/telephony.actions';
    import { AmplitudeLogger, EVENTS, formatNumber } from '../../services/utils';
    import pubsub from 'sweet-pubsub'

    const navigate = useNavigate();
    const location = useLocation();

    let contact: any = {}
    let profile: Profile = $sessionStore.profile || {}
    let loading: boolean = false

    const handleContactSubmit = async () => {
        contact.name = `${contact.first_name} ${contact.last_name}`

        loading = true
        try {
            const response = !contact.id ? await CreateContact($sessionStore.profile.business.id, contact) :
                await UpdateContact($sessionStore.profile.business.id, contact, contact.id)
            toast.success(`${contact.name} has been updated`)
            pubsub.emit('contact_saved', response)
            AmplitudeLogger.log(EVENTS.CONTACT_SAVED)
        } catch (e) {
            console.log(e)
            toast.error({message: "Ops! an error occured while updating contact"})
        } finally {
            loading = false
        }
    }

    onMount(() => {
        if($location.state.id || $location.state.number) {
            const { id, name, number } = $location.state
            if (id) contact.id = id
            if (number) contact.number = number
            if (name) {
                const names = name.split(" ")
                contact.first_name = names[0]
                if (names[1]) {
                    contact.last_name = names[1]
                }
            }
        }
    })
</script>

<AuthHeader />
<div class="flex h-full flex-col mx-4 overflow-y-scroll">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="text-gray-500 flex items-center mt-1" on:click={() => navigate(-1)}>
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer mr-1">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.785 2.965L1.75 6L4.785 9.035" stroke="#344054" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.25 6H1.83496" stroke="#344054" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>                     
        </span>
        Go Back
    </div>
    <div class="flex justify-between my-3">
        <div class="flex">
            <div class="flex justify-center items-center bg-gradient-to-r from-green-400 to-blue-500 rounded-full h-10 w-10 text-white">AS</div>
            <div class="ml-2">
                <div class="font-light text-xs">{ contact.first_name || "n/a" } { contact.last_name || "n/a" }</div>
                <div class="text-gray-500 text-xs flex">
                    <span>{ contact.mobile || "n/a" }</span>
                </div>
            </div>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="flex cursor-pointer" on:click={initiateCall(formatNumber(contact.number), {})}>
            <div class="flex justify-center items-center text-gray-700 mr-2 text-xs underline">Call contact</div>
            <div class="flex justify-center items-center primary-bg-color rounded-full h-10 w-10 text-white cursor-pointer">
                <Icon icon="ringing" color="#ffffff"/>
            </div>
        </div>
    </div>
    <hr/>
    <h3 class="text-md font-bold my-3 secondary-text-color">Profile Information</h3>
    <div class="text-xs overflow-y-scroll" style="height: 10rem;">
        <div class="bg-gray-100 font-black py-1 my-2 primary-text-color">Personal Information</div>
        <div class="grid grid-cols-3 text-gray-500">
            <div class="my-1">Phone:</div>
            <div class="my-1 col-span-2">
                <input
                    placeholder="08012345678"
                    bind:value={contact.number}
                    class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                />
            </div>
            <div class="my-1">First Name:</div><div class="my-1 col-span-2">
                <input
                    placeholder="John"
                    bind:value={contact.first_name}
                    disabled={loading}
                    class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                />
            </div>
            <div class="my-1">Last Name:</div><div class="my-1 col-span-2">
                <input
                    placeholder="Doe"
                    bind:value={contact.last_name}
                    disabled={loading}
                    class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                />
            </div>
            <div class="my-1">Email:</div><div class="my-1 col-span-2">
                <input
                    placeholder="contact@email.com"
                    bind:value={contact.email}
                    disabled={loading}
                    class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                />
            </div>
            <div class="my-1">Company:</div>
            <div class="my-1 col-span-2">
                <input
                    placeholder=""
                    bind:value={contact.company}
                    disabled={loading}
                    class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                />
            </div>
            <ButtonRounded
                loading={loading}
                on:click={handleContactSubmit}
                size=8
                title=""
                className="call-btn-bg-color h-10 mt-4 w-full flex-inline text-white px-8"
            >
            Submit
            </ButtonRounded>
        </div>
    </div>
</div>
<AuthFooter />
<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .primary-bg-color {
        background-color: var(--primary-bg-color)
    }
</style>
